export default {
  namespaced: true,
  state: {
    appLoaderStep: 0,
  },
  mutations: {
    toggleAppLoader: (state, appLoader) => {
      if (appLoader) {
        state.appLoaderStep++
      } else {
        state.appLoaderStep--
      }
      if (state.appLoaderStep < 0) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('Wrong toggleAppLoader() call detected')
        }
        state.appLoaderStep = 0
      }
    },
  },
  getters: {
    appLoader: (state) => {
      return state.appLoaderStep > 0
    },
  },
}
